import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const roundPlaceholderDefaultVariants = {}
const roundPlaceholderCompoundVariants = []

const roundPlaceholderSlotNames = [
  [
    "root",
    "round-placeholder__root"
  ],
  [
    "icon",
    "round-placeholder__icon"
  ]
]
const roundPlaceholderSlotFns = /* @__PURE__ */ roundPlaceholderSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, roundPlaceholderDefaultVariants, getSlotCompoundVariant(roundPlaceholderCompoundVariants, slotName))])

const roundPlaceholderFn = memo((props = {}) => {
  return Object.fromEntries(roundPlaceholderSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const roundPlaceholderVariantKeys = []
const getVariantProps = (variants) => ({ ...roundPlaceholderDefaultVariants, ...compact(variants) })

export const roundPlaceholder = /* @__PURE__ */ Object.assign(roundPlaceholderFn, {
  __recipe__: false,
  __name__: 'roundPlaceholder',
  raw: (props) => props,
  variantKeys: roundPlaceholderVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, roundPlaceholderVariantKeys)
  },
  getVariantProps
})